module.exports = __webpack_public_path__ + "media/images/icon-item@3x-f26b2748aeee6580e557496dfb5e4008.png";